var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"center_img"},[_c('img',{attrs:{"src":"http://ww1.sinaimg.cn/large/70bfbc22gy1g1g1g4ra6dj207a063408.jpg"}}),_c('br'),_c('br'),_c('a-button',{attrs:{"type":"primary"},on:{"click":_vm.go_home}},[_vm._v("首页")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }